export enum InflowPeriod {
  OneDay = "1 day",
  TwoDays = "2 days",
  ThreeDays = "3 days",
  FourDays = "4 days",
}
